import { SeatJson } from './seat-json';

export interface TicketDetailToken {
  giftRecipient: string;
  sodId: number;
  seat: SeatJson;
  mailCategory: MailCategory;
  saleId:any;
}

export enum MailCategory {
  E_TICKETS = 'E_TICKETS',
  SMARTPHONE = 'SMARTPHONE',
  MAIL = 'MAIL',
  WILLCALL = 'WILLCALL'
}
